import { render } from "./CropManagerIcon.vue?vue&type=template&id=584981ba"
import script from "./CropManagerIcon.vue?vue&type=script&lang=js"
export * from "./CropManagerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__